import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { mapRoot } from './config.tsx'

ReactDOM.createRoot(document.getElementById(mapRoot)!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
